import { makeStyles } from '@fluentui/react';
export const useStyles = makeStyles((theme) => ({
  categoryType: {
    color: theme.palette.themePrimary,
  },
  typeContainer: { alignItems: 'center', margin: '10px 20px', width: 150 },

  callout: {
    backgroundColor: theme.palette.neutralLighterAlt,
  },
 

  accessGroup: {
    height: 30,
    padding: 10,
    backgroundColor: theme.palette.themePrimary,
    borderRadius: 5,
  },
  backgroundWithoutIsAlert: {
    borderRadius: 5,
    backgroundColor: theme.palette.themePrimary,
  },
  fontColor: {
    color: 'white',
  },
}));
